module.exports = __webpack_public_path__ + "static/media/img_fenlei13.17ad4f17.png";